import React from 'react';
import Helmet from "react-helmet";
import DiscountInclude from '../../components/includes/discountInclude';
import PaymentMethodsInclude from '../../components/includes/paymentMethodsInclude';
import FAQinclude from '../../components/includes/FAQinclude';
import InfoPointsDDoS from './infoPoints';

class DDoSProtectionSwitzerland extends React.Component {

	render() {

		return (
			<React.Fragment>
				<Helmet>
					<title>DDoS Attack Protection in Switzerland | Swiss Made Host</title>
					<meta name="description" content="Professional on-site and remote protection against all types of DDoS attacks with SLA-backed guarantee. Proudly made in Zurich, Switzerland." />
					<link rel="canonical" href="https://swissmade.host/en/ddos-protection-switzerland" />
				</Helmet>
				<div className="fullwidth pic ddos-protection">
					<div className="row">
						<div className="twelve columns">
							<div className="transparent">
								<h1 className="title">DDoS Protection in <span><i className="fa fa-plus-square" aria-hidden="true"></i> Switzerland</span></h1>
								<h2>100% SLA-backed Mitigation Guarantee</h2>
							</div>
						</div>
					</div>
				</div>
				<DiscountInclude />
				<InfoPointsDDoS />
				<FAQinclude category={'ddos'} color={'light'} />
				<PaymentMethodsInclude />

			</React.Fragment>
		)
	}
}

export default DDoSProtectionSwitzerland;